<div class="flex flex-row items-center gap-2"
     [class.rounded-full]="showLabel"
     [class.overflow-hidden]="showLabel"
     [class.border]="showLabel"
     [class.border-surface-200 dark:border-surface-700]="showLabel"
     [class.px-4]="showLabel"
     [class.py-1.5]="showLabel">
  @if (showLabel) {
    @if (isOnline) {
      <span class="text-sm">Online</span>
    } @else {
      <span class="text-sm">Offline</span>
    }
  }
  @if (isOnline) {
    <div class="inline-block rounded-full bg-zaeper-success-500 h-[10px] w-[10px]"></div>
  } @else {
    <div class="inline-block rounded-full bg-surface-400 dark:bg-surface-500 h-[10px] w-[10px]"></div>
  }
</div>
